var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLoginFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16.6C0 10.9051 0 8.05764 1.12587 5.89026C2.07462 4.06382 3.56382 2.57462 5.39026 1.62587C7.55764 0.5 10.4051 0.5 16.1 0.5H31.9C37.5949 0.5 40.4424 0.5 42.6097 1.62587C44.4362 2.57462 45.9254 4.06382 46.8741 5.89026C48 8.05764 48 10.9051 48 16.6V32.4C48 38.0949 48 40.9424 46.8741 43.1097C45.9254 44.9362 44.4362 46.4254 42.6097 47.3741C40.4424 48.5 37.5949 48.5 31.9 48.5H16.1C10.4051 48.5 7.55764 48.5 5.39026 47.3741C3.56382 46.4254 2.07462 44.9362 1.12587 43.1097C0 40.9424 0 38.0949 0 32.4V16.6Z",
    fill: "url(#paint0_linear_16242_44774)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3333 31.1673L34.4 24.5007H28V19.834C28 17.9673 28.6667 16.5007 31.6 16.5007H34.6667V10.3673C32.9333 10.1007 31.0667 9.83398 29.3333 9.83398C23.8667 9.83398 20 13.1673 20 19.1673V24.5007H14V31.1673H20V48.5007C22.6667 48.5007 25.3333 48.5007 28 48.5007V31.1673H33.3333Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16242_44774",
    x1: 24,
    y1: 47.0975,
    x2: 24,
    y2: 0.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0062E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19AFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLoginFacebook);
export default __webpack_public_path__ + "static/media/icon_login_facebook.17255fa1ad14cd2a83f7deb8ca1c1d4f.svg";
export { ForwardRef as ReactComponent };